import { render, staticRenderFns } from "./JobManagement.vue?vue&type=template&id=98ef40fe&scoped=true"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"
import style0 from "./JobManagement.vue?vue&type=style&index=0&id=98ef40fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef40fe",
  null
  
)

export default component.exports